import type { Href } from 'expo-router';

// The async inputs the resolver may still need before it can decide a route.
// (The prescribed-programs catalog is NOT here: it doesn't block routing — the
// resolver routes into the program region immediately and the screen skeletons
// while the catalog loads.)
export type RoutingResource =
  | 'partners'
  | 'programInstances'
  | 'metricPoints'
  | 'teams'
  // The `onb_use_dynamic_assessment` flag read — needed before the survey start
  // can be decided (test arm enters at /step/assigned-screeners, control at
  // /step/health-conditions).
  | 'dynamicAssessment';

// The manager's output: either a definitive route, or the next data-need the
// driver must satisfy (fetch) before re-resolving.
export type Resolution =
  | { kind: 'route'; href: Href }
  | { kind: 'need'; resource: RoutingResource };

// Uniform 4-state wrapper for a single derived async value (hasProgram /
// surveyComplete / hasCoach). Mirrors PartnersState's status field so the
// resolver treats every input the same way. `error` carries no value — callers
// fail open (treat it as the safe default, e.g. hasProgram=false → survey).
export type ResourceState<T> =
  | { status: 'unset'; value: undefined }
  | { status: 'loading'; value: undefined }
  | { status: 'ready'; value: T }
  | { status: 'error'; value: undefined };

export const UNSET: ResourceState<never> = { status: 'unset', value: undefined };
